<template>
    <div>
        <sui-header size="huge">
            Synthèse {{ customer.name }}
        </sui-header>

        <sui-card-group :items-per-row="4" stackable id="customer-overview">
            <sui-card class="raised link">
                <sui-header size="huge" v-on:click="goToGateway()">
                    {{ $t('common.gateways') }}
                </sui-header>
            </sui-card>

            <sui-card class="raised link">
                <sui-header size="huge" v-on:click="goToTemplates()">
                    {{ $t('common.templates') }}
                </sui-header>
            </sui-card>

            <sui-card class="raised link">
                <sui-header size="huge" v-on:click="goToWorkshopSchedule()">
                    Plannings Ateliers
                </sui-header>
            </sui-card>

            <sui-card class="raised link">
                <sui-header size="huge" v-on:click="onEditTag()">
                    {{ $t('customers.list.editTags') }}
                </sui-header>

                <sui-card-content v-if="customer.tag_ids.length > 0">
                    <div class="overview-card-tag-container">
                        <TagPill v-for="tag in customer.tag_ids" :key="tag"
                            v-bind:tag-id="tag"
                            v-bind:tag-collection="tags"
                        />
                    </div>
                </sui-card-content>
            </sui-card>
        </sui-card-group>

        <!-- Modal edit tags -->

        <sui-modal v-model="is_editing_tag">
            <sui-modal-header>{{ $t('customers.list.editTags') }}</sui-modal-header>
            <sui-modal-content>
                <div class="wrap">
                    <div v-for="tag in tags" :key="tag.id" class="modal-tag">
                        <sui-checkbox toggle v-model="tag.selected"/>
                        <TagPill
                            v-bind:tag-id="tag.id"
                            v-bind:tag-collection="tags"
                        />
                    </div>
                </div>
            </sui-modal-content>
            <sui-modal-actions>
                <sui-button class="tiny" v-on:click="closeModal()">
                    {{ $t('common.cancel') }}
                </sui-button>
                <sui-button class="tiny violet" v-on:click="onAcceptTagsEdit()">
                    {{ $t('common.save') }}
                </sui-button>
            </sui-modal-actions>
        </sui-modal>
    </div>
</template>

<script>
    import TagPill from '@/components/tag/TagPill.vue';
    import { api } from '@/api';
    import store from '@/store';

    export default {
        name: 'CustomerOverview',
        components: {
            TagPill,
        },
        beforeDestroy() {
            store.commit('removeAppTitle');
        },
        mounted() {
            store.commit('setAppTitle', `${this.$t('common.customer')}`);
        },
        data() {
            return {
                customer: {
                    id: this.$route.params.customer_id,
                    tag_ids: [],
                },
                tags: [],
                filtered_tags: [],
                is_editing_tag: false,
            }
        },
        async created() {
            await Promise.all([
                this.getTags(),
                this.getCustomer()
            ]);

            store.commit('setAppTitle', `${this.customer.name} - ${this.$t('common.customer')}`);
        },
        methods: {
            async getTags() {
                this.tags = await api.customers.getTags();
            },

            async getCustomer() {
                this.customer = await api.customers.getOverview(this.customer.id);
            },

            closeModal() {
                this.is_editing_tag = false;
            },

            goToTemplates() {
                this.$router.push({
                    path: `/customers/${this.customer.id}/templates`,
                    query: {
                        customer_name: this.customer.name
                    }
                })
            },

            goToGateway() {
                this.$router.push({
                    name: 'CustomerGatewaysList',
                    params: {
                        customer_id: this.customer.id,
                    }
                })
            },

            goToWorkshopSchedule() {
                this.$router.push({
                    name: 'CustomerWorkshopScheduleList',
                    params: {
                        customer_id: this.customer.id,
                    }
                })
            },

            onEditTag() {
                try {
                    this.tags.forEach(t => t.selected = false);
                    for (const tag of this.customer.tag_ids) {
                        this.tags.find(t => t.id === tag).selected = true;
                    }
                    this.is_editing_tag = true;
                } catch (e) {
                    console.log(e);
                }
            },

            async onAcceptTagsEdit() {
                const selectedTagIds = this.tags.filter(t => t.selected).map(t => t.id);
                try {
                    const response = await api.customers.updateTags(this.customer.id, selectedTagIds);

                    this.customer.tag_ids = response.tag_ids;
                } catch (err) {
                    console.error(err);
                } finally {
                    this.closeModal();
                }
            },
        }
    }
</script>

<style>
#customer-overview.ui.cards {
    align-items: flex-start;
}

#customer-overview .header {
    padding: 30px 0;
    display: block;
    width: 100%;
    text-align: center;
    color: black;
}

#customer-overview .header:hover {
    cursor: pointer;
}

#customer-overview a {
    color: black;
}

#customer-overview .overview-card-tag-container {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
}

#customer-overview .overview-card-tag-container .ui.label {
    margin: 5px;
    flex-basis: 25%;
    flex-grow: 1;
    text-align: center;
}
</style>